import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { Button } from 'rsuite';

const DeckActions = ({ selectedCount, onBulkDelete, disabled, spacing, colors }) => {
  if (selectedCount === 0) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: spacing.actionItemGap, whiteSpace: 'nowrap' }}>
      <span style={{ fontSize: 12, color: colors.muted }}>
        {selectedCount} card{selectedCount !== 1 ? 's' : ''} selected
      </span>
      <Button
        size={isMobile ? 'md' : 'sm'}
        color="red"
        appearance="primary"
        onClick={onBulkDelete}
        disabled={disabled || selectedCount === 0}
      >
        Delete Selected
      </Button>
    </div>
  );
};

DeckActions.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onBulkDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  spacing: PropTypes.object.isRequired,
  colors: PropTypes.object.isRequired,
};

DeckActions.defaultProps = {
  disabled: false,
};

export default DeckActions;
